import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import { actionGetEmpresaMovementList } from "../../actions/BoletaActions";
import { TextField } from "redux-form-material-ui";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from "material-ui/Table";
import { INDEX } from "../../config/RoutesConstants";
import { FlatButton } from "material-ui";
import { ROL_ADMIN, ROL_EMPRESA } from "../../common/Constants";
import { Card, CardTitle, CardText } from "material-ui/Card";
import Util from "../../common/Util";

class EmpresaMovements extends Component {
	constructor(props) {
		super(props);
		this.state = {
			rol: this.props.rol,
			saldo: 0
		};

		this.renderBodyRows = this.renderBodyRows.bind(this);
		this.calculoSaldo = this.calculoSaldo.bind(this);
	}

	componentWillMount() {
		if (this.props.rol === ROL_EMPRESA) this.props.history.push(INDEX);
		if (this.props.rol === ROL_ADMIN);
		let id = this.props.empresa.id;
		this.props.actionGetEmpresaMovementList(id);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.rol !== nextProps.rol && nextProps.rol === ROL_EMPRESA) {
			this.props.history.push(INDEX);
		}
		if (nextProps.boletasList) {
			this.calculoSaldo(nextProps.boletasList);
		}
	}

	calculoSaldo(listBoletas) {
		let total = 0;

		if (listBoletas.length !== 0) {
			_.map(listBoletas, item => {
				if (
					item.ticketHeader.status === "VENCIDO" ||
					item.ticketHeader.status === "ANULADO" ||
					item.ticketHeader.status === "PAGADO"
				) {
					total = total + 0;
				} else {
					if (item.pago > item.total) {
						total = total + 0;
					} else {
						total = total + item.saldo;
					}
				}
			});
		}
		this.setState({ saldo: Math.round(total * 100) / 100 });
	}

	renderBlank() {
		let mensaje = "";
		if (this.props.busquedaRealizada) {
			mensaje = "No se encontraron resultados";
		} else {
			mensaje = "Aplique un criterio de búsqueda para visualizar datos";
		}
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>{mensaje}</p>
				</TableRowColumn>
			</TableRow>
		);
	}

	renderBodyRows(boletasList) {
		return _.map(boletasList, (item, i) => {
			return (
				<TableRow key={i} style={{ height: "16px", fontSize: "12px" }}>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{item.monthPeriod}/{item.yearPeriod}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{item.ticketHeader.ticketNumber}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{item.paymentTitle}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{item.ticketHeader.status}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{item.pago > item.total ? item.pago : item.total}
					</TableRowColumn>
					<TableRowColumn style={{ marginLeft: 20 }}>
						{item.pago}
					</TableRowColumn>
				</TableRow>
			);
		});
	}

	render() {
		return (
			<div className="center">
				<Card className="card">
					<CardTitle title="Cuenta Corriente" />
					<CardText>
						<Table selectable={false}>
							<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
								<TableRow>
									<TableHeaderColumn>Periodo</TableHeaderColumn>
									<TableHeaderColumn>Nº Ticket</TableHeaderColumn>
									<TableHeaderColumn>Concepto</TableHeaderColumn>
									<TableHeaderColumn>Estado</TableHeaderColumn>
									<TableHeaderColumn>Importe</TableHeaderColumn>
									<TableHeaderColumn>Pago</TableHeaderColumn>
								</TableRow>
							</TableHeader>
							<TableBody stripedRows displayRowCheckbox={false}>
								{!_.isEmpty(this.props.boletasList)
									? this.renderBodyRows(this.props.boletasList)
									: this.renderBlank()}
							</TableBody>
						</Table>
					</CardText>
				</Card>
				<Card className="card">
					<CardTitle title="Saldo" />
					<CardText>
						<TextField
							name="partialPayment"
							value={Util.formatPesos(this.state.saldo)}
							floatingLabelText="Saldo"
							disabled
						/>
					</CardText>
				</Card>
				<div className="top20 text-right">
					<FlatButton
						label="Volver"
						onClick={() => this.props.history.goBack()}
						style={{ margin: 5 }}
					/>
				</div>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		empresa: store.empresa.empresa,
		boletasList: store.boleta.boletasList,
		movementList: store.empresa.movementList,
		loadingText: store.empresa.loadingText,
		modeCRU: store.empresa.modeCRU,
		rol: store.app.rol
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionGetEmpresaMovementList
		},
		dispatch
	);
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EmpresaMovements);



// WEBPACK FOOTER //
// ./src/screens/Empresa/EmpresaMovements.js